var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 3.33464H12.5V6.66797H15.8333V16.668H4.16667V3.33464ZM3.33208 1.66797C2.87291 1.66797 2.5 2.03801 2.5 2.49447V17.5081C2.5 17.9552 2.87063 18.3346 3.32783 18.3346H16.6722C17.1292 18.3346 17.5 17.9587 17.5 17.4951L17.4998 5.83464L13.3333 1.66797H3.33208ZM8.74992 6.2513C8.74992 7.56588 8.37017 9.11572 7.72911 10.5458C7.08572 11.9811 6.21786 13.2098 5.3127 13.9339L6.29553 15.2781C8.73508 13.6516 11.4361 12.5364 14.0487 12.9096L14.4302 11.2941C12.2029 10.5516 10.4166 8.32625 10.4166 6.2513H8.74992ZM9.24992 11.2276C9.47275 10.7306 9.67017 10.2149 9.83642 9.69172C10.2294 10.2956 10.7128 10.8498 11.2584 11.3307C10.4402 11.4772 9.63875 11.7176 8.86267 12.0243C8.99992 11.7632 9.12925 11.497 9.24992 11.2276Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfLine);
export default __webpack_public_path__ + "static/media/pdf-line.47f7ad9bf19584de3d5efffb08c840f8.svg";
export { ForwardRef as ReactComponent };